import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { updateSingleFilter, updateAllFilters } from '@src/store/slices/searchFiltersSlice';

// ---------------------------------------------------------

import RadioButtons from '../';

// ---------------------------------------------------------

const RadioButtonRedux = (props) => {
  const { groupName } = props;

  const dispatch = useDispatch();
  const selection = useSelector((state) => state.searchFilters[groupName]);
  const { propertySubSelectIds } = useSelector((state) => state.searchFilters);

  const subSelections = groupName === 'propertyTypeId' ? propertySubSelectIds : null;

  const onChange = (value) => {
    dispatch(updateSingleFilter({ group: groupName, value }));
    // TODO move sub select handling into reducer and use propertyTypeMap?
    if (groupName === 'propertyTypeId') {
      switch (value) {
        case '1':
          dispatch(updateAllFilters({ group: 'propertySubSelectIds', value: ['1', '2'] }));
          break;
        case '2':
          dispatch(updateAllFilters({ group: 'propertySubSelectIds', value: ['4'] }));
          break;
        default:
          dispatch(updateAllFilters({ group: 'propertySubSelectIds' }));
      }
    }
  };

  const onSubChange = (value) => {
    dispatch(updateAllFilters({ group: 'propertySubSelectIds', value }));
  };

  // ---------------------------------------------------------

  return (
    <RadioButtons
      {...props}
      selection={selection}
      subSelections={subSelections}
      onChange={onChange}
      onSubChange={onSubChange}
    />
  );
};

RadioButtonRedux.propTypes = {
  /**
   * Specifies the name of the redux group of the radio buttons
   */
  groupName: PropTypes.string
};

RadioButtonRedux.defaultProps = {};

export default RadioButtonRedux;
